import { API_BASE_URL as API_BASE } from '../config/api';
import { createApiResponse, createCompanyStatistics } from '../models';
import { createAuthenticatedApiClient } from './authenticatedApiClient';

const apiClient = createAuthenticatedApiClient({
  baseURL: `${API_BASE}/api/v1`,
});

const mapCompanyStatistics = (raw) => {
  if (!raw) return null;
  return createCompanyStatistics({
    total_companies: raw.totalCompanies ?? raw.total_companies,
    companies_with_risk_analysis:
      raw.companiesWithRiskAnalysis ?? raw.companies_with_risk_analysis,
    ...raw,
  });
};

const mapWatchlistStatistics = (raw) => {
  if (!raw) return null;
  return {
    totalCompanies: raw.totalCompanies ?? raw.total_companies ?? 0,
    alertsEnabledCount: raw.alertsEnabledCount ?? raw.alerts_enabled_count ?? 0,
    priorityDistribution: raw.priorityDistribution ?? raw.priority_distribution ?? {
      high: 0,
      normal: 0,
      low: 0,
    },
  };
};

export const dashboardService = {
  async getBootstrap(userId) {
    if (!userId) {
      return createApiResponse({ success: false, message: 'User not authenticated' });
    }
    try {
      const response = await apiClient.get('/dashboard/bootstrap', {
        params: { userId },
      });
      const apiResponse = createApiResponse(response.data);
      if (!apiResponse.success || !apiResponse.data) {
        return apiResponse;
      }

      const data = apiResponse.data;
      return createApiResponse({
        success: true,
        data: {
          companyStatistics: mapCompanyStatistics(
            data.company_statistics ?? data.companyStatistics
          ),
          watchlistStatistics: mapWatchlistStatistics(
            data.watchlist_statistics ?? data.watchlistStatistics
          ),
          newsSidebar: data.news_sidebar ?? data.newsSidebar ?? null,
          watchlistGraph: data.watchlist_graph ?? data.watchlistGraph ?? null,
        },
      });
    } catch (error) {
      return createApiResponse({
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to fetch dashboard bootstrap',
      });
    }
  },
};
